import type { VignetteDefinition } from "./types";

/** Holiday vignette — a small flag EnvironmentDecorator plants for Independence Day; "Wave" fits the celebratory moment directly. */
export const july4thVignette: VignetteDefinition = {
  id: "july4th",
  name: "A flag on the sand",
  category: "holiday",
  weight: 1, // irrelevant — holiday vignettes bypass weighted selection (see SceneDirector)
  animationClip: "Wave",
  loopAnimation: true,
  durationMs: 5000,
  cameraFraming: {
    offset: { x: -2, y: 2, z: 2 },
    targetOffset: { x: 0.25, y: 0.8, z: -0.65 },
  },
  dateWindow: { startMonth: 6, startDay: 30, endMonth: 7, endDay: 5 },
  audioCues: [],
  onEnter: (ctx) => ctx.decorator.setHoliday("july4th"),
  onExit: (ctx) => ctx.decorator.setHoliday(null),
};
